export default __webpack_public_path__ + "static/cedric-glenda-justin-matthew-marcus-26713461096b1c3a96e6fa76dece5bff.png";